export class Controller {

    /** @ngInject */
    constructor($state, Alert, DestructiveOperationModal) {
        this.$state = $state;
        this.Alert = Alert;
        this.DestructiveOperationModal = DestructiveOperationModal;
    }

    $onInit() {
        this.keepAccounts = true;
    }

    remove() {
        // DirectoriesResource.deleteDirectory()
        const url = `app/rest/v2/company/${this.companyId}/directories/${this.directory.id}?keepAccounts=${this.keepAccounts}`;

        this.DestructiveOperationModal({
            titleKey: 'company.directory-integration.manage.main.remove.$title',
            textKey: 'company.directory-integration.manage.main.remove.are-you-sure',
            http: {method: 'DELETE', url},
        }).then(() => {
            this.Alert('success', 'company.directory-integration.manage.main.remove.removed');
            this.$state.go('company.directory-integration', {}, {reload: true});
        });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/main/remove/remove-directory.controller.js